<script type="text/javascript">
// 定义一些公共的属性和方法

// // //主地址
// const mainUrl = "http://localhost:8996/";
// // //上传Excel地址
// const uploadUrl = "http://localhost:8996/hwUploadExcel";

// //下载地址
// const downMbUrl = "http://localhost:8996/ptmainApi/excelDownFile";

// //webSocket地址
// const webSocketUrl = "ws://localhost:8996/ppq/socket";
// const uploadImgUrl = "http://localhost:8996/pttyUploadImage";
// const adminBmUploadImage =
//   "http://localhost:8996/pttyUploadImage/adminBmUploadImage";

//主地址;
const mainUrl = "http://192.168.0.116:6868/";
//上传Excel地址;
const uploadUrl = "https://www.youfanglianmai.com/ptmainApi/excelDownFile";

//下载地址;
const downMbUrl = "https://www.youfanglianmai.com/ptmainApi/excelDownFile";

//webSocket地址;
const webSocketUrl = "ws://192.168.0.116:6868/ppq/socket";
const uploadImgUrl = "https://www.youfanglianmai.com/ptmainApi/pttyUploadImage";
const adminBmUploadImage =
  "https://www.youfanglianmai.com/ptmainApi/pttyUploadImage";

// 暴露出这些属性
export default {
  uploadUrl,
  downMbUrl,
  webSocketUrl,
  mainUrl,
  uploadImgUrl,
  adminBmUploadImage
};
</script>



// WEBPACK FOOTER //
// src/allParam/allParam.vue